import gsap from "gsap";
import Splitexpand from './util/splitexpand';

const splitexpand = new Splitexpand({
    el:"#split-expand",
    resetArr:["50%", "50%"],
    over:"70%",
    down:"30%",
    speed:770
});

let basicAnimation = gsap.timeline({paused:true})
    // .set($(".split-expand__list--wrap1"), {width:"100%"}, "-=0.0")
    .from($(".split-expand"), 0.95, {autoAlpha:0, ease:"Sine.easeOut"}, "-=0.0")
    // .fromTo($(".split-expand__list--wrap2"), 0.69, {width:"0%"}, {width:"100%", ease:"Expo.easeOut"}, "+=0.035")
    // .set($(".split-expand__list--wrap1"), {width:"0%", zIndex:1}, "-=0.0")
    // .to($(".split-expand__list--wrap1"), 0.49, {width:"50%", ease:"Expo.easeOut"}, "+=0.1")
    // .to($(".split-expand__list--wrap1"), 0.22, {width:"50%", ease:"Expo.easeOut"}, "-=0.0")
    // .set($(".split-expand__list--wrap2"), {width:"50%", zIndex:1})
    .addLabel("txtAni")
    .from($(".classic__tit"), 0.92, {x:150, autoAlpha:0, ease:"Power1.easeOut"}, "-=0.1")
    .from($(".classic__date"), 0.92, {x:150, autoAlpha:0, ease:"Power1.easeOut"}, "-=0.83")
    .from($(".classic__btn"), 0.92, {x:150, autoAlpha:0, ease:"Power1.easeOut"}, "-=0.83")
    .from($(".live__tit"), 0.92, {x:-150, autoAlpha:0, ease:"Power1.easeOut"}, "txtAni-=0.1")
    .from($(".live__date"), 0.92, {x:-150, autoAlpha:0, ease:"Power1.easeOut"}, "-=0.83")
    .from($(".live__btn"), 0.92, {x:-150, autoAlpha:0, ease:"Power1.easeOut"}, "-=0.83")
    .call(function(){
        splitexpand.overAction = true;
    });

let classicAnimation = gsap.timeline({paused:true})
    .to($(".classic__tit"), 1.1, {x:-200, y:50, autoAlpha:0.55, ease:"Expo.easeInOut"}, "+=0.0")
    .to($(".classic__date"), 1.1, {x:-200, y:50, autoAlpha:0.55, ease:"Expo.easeInOut"}, "-=1.1")
    .to($(".classic__btn"), 1.1, {x:-200, y:50, autoAlpha:0.55, ease:"Expo.easeInOut"}, "-=1.1");

let liveAnimation = gsap.timeline({paused:true})
    .to($(".live__tit"), 1.1, {x:200, y:50, autoAlpha:0.55, ease:"Expo.easeInOut"}, "+=0.0")
    .to($(".live__date"), 1.1, {x:200, y:50, autoAlpha:0.55, ease:"Expo.easeInOut"}, "-=1.1")
    .to($(".live__btn"), 1.1, {x:200, y:50, autoAlpha:0.55, ease:"Expo.easeInOut"}, "-=1.1");

splitexpand.on("mouseEnter",()=>{
    if(splitexpand.currIdx===0){
        liveAnimation.play();
        classicAnimation.reverse();
    }else{
        classicAnimation.play();
        liveAnimation.reverse();
    }
});

splitexpand.on("mouseLeave",()=>{
    classicAnimation.reverse();
    liveAnimation.reverse();
});

splitexpand.overAction = false;

let networkLink = {
    "file":"https://opdev-aion.plaync.com",
    "local":"https://opdev-aion.plaync.com",
    "op":"https://opdev-aion.plaync.com",
    "rc":"https://rc-aion.plaync.com",
    "live":"https://aion.plaync.com",
};

let updateLink = {
    classic:`${networkLink[promokit.store('network')]}/update/history/2021/210407_update`,
    live:`${networkLink[promokit.store('network')]}/update/history/2021/210414_update`
};

$.each(updateLink, (key, value)=>{
    $(`.${key}__btn`).attr("href", `${value}`);
});

$(window).on("resize", function(){
    $(".split-expand__con").css({width:$(window).width()});
});

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        fixed: true,
        theme:'white'
    },
    headerButton:{
        cookie:{
            type:'year',
            key:'INDEX_WEB_VISIT_210414_index',
            value:false
        },
        home:true,
        event:true,
        sns:true,
        theme:'black'
    },
});

promokit.preload({
    complete:function(){
        basicAnimation.play();
    }
});



// WEBPACK FOOTER //
// ./src/js/index.js